const locale = {
	"editor.remove": "Supprimer",
	"editor.copy": "Copier",
	"editor.words": "MOTS",
	"editor.characters": "CARACTÈRES",
	"editor.default": "Par défaut",
	"editor.recent": "Récemment utilisé",
	"editor.nofill": "Sans remplissage",
	"editor.format": "Pinceau de format",
	"editor.delete": "Supprimer",
	"editor.edit": "Modifier",
	"editor.settings": "Paramètres",
	"editor.table_of_content": "Tableau des matières",
	"editor.draghandle.tooltip": "Modifier",
	"editor.copyToClipboard": "Copier dans le presse-papiers",
	"editor.slash": "Appuyez sur '/' pour les commandes",
	"editor.slash.empty": "Aucun résultat",
	"editor.slash.format": "Format",
	"editor.slash.insert": "Insérer",
	"editor.slash.embed": "Intégrer des services",
	"editor.content": "Veuillez saisir du contenu",
	"editor.fontFamily.tooltip": "Police de caractères",
	"editor.fontFamily.default.tooltip": "Par défaut",
	"editor.moremark": "Plus de styles de texte",
	"editor.size.small.tooltip": "Petit",
	"editor.size.medium.tooltip": "Moyen",
	"editor.size.large.tooltip": "Couverture",
	"editor.bold.tooltip": "Gras",
	"editor.italic.tooltip": "Italique",
	"editor.underline.tooltip": "Souligné",
	"editor.strike.tooltip": "Barré",
	"editor.color.tooltip": "Couleur",
	"editor.color.more": "Plus de couleurs",
	"editor.highlight.tooltip": "Surligner",
	"editor.lineheight.tooltip": "Hauteur de ligne",
	"editor.heading.tooltip": "Titres",
	"editor.heading.h1.tooltip": "Titre 1",
	"editor.heading.h2.tooltip": "Titre 2",
	"editor.heading.h3.tooltip": "Titre 3",
	"editor.heading.h4.tooltip": "Titre 4",
	"editor.heading.h5.tooltip": "Titre 5",
	"editor.heading.h6.tooltip": "Titre 6",
	"editor.paragraph.tooltip": "Paragraphe",
	"editor.textalign.tooltip": "Alignement",
	"editor.textalign.left.tooltip": "Gauche",
	"editor.textalign.center.tooltip": "Centré",
	"editor.textalign.right.tooltip": "Droite",
	"editor.textalign.justify.tooltip": "Justifié",
	"editor.indent": "Indentation",
	"editor.indent.indent": "Augmenter l'indentation",
	"editor.indent.outdent": "Réduire l'indentation",
	"editor.fontSize.tooltip": "Taille de police",
	"editor.fontSize.default.tooltip": "Par défaut",
	"editor.superscript.tooltip": "Exposant",
	"editor.subscript.tooltip": "Indice",
	"editor.bulletlist.tooltip": "Liste à puces",
	"editor.orderedlist.tooltip": "Liste numérotée",
	"editor.tasklist.tooltip": "Liste de tâches",
	"editor.indent.tooltip": "Indentation",
	"editor.outdent.tooltip": "Désindentation",
	"editor.columns.tooltip": "Colonnes",
	"editor.link.tooltip": "Lien",
	"editor.link.unlink.tooltip": "Supprimer le lien",
	"editor.link.open.tooltip": "Ouvrir le lien",
	"editor.link.edit.tooltip": "Modifier le lien",
	"editor.link.dialog.title": "Insérer un lien",
	"editor.link.dialog.link": "Lien",
	"editor.link.dialog.text": "Texte",
	"editor.link.dialog.openInNewTab": "Ouvrir dans un nouvel onglet",
	"editor.link.dialog.link.placeholder": "Adresse du lien",
	"editor.link.dialog.text.placeholder": "Ajouter une description",
	"editor.link.dialog.button.apply": "Appliquer",
	"editor.image.tooltip": "Image",
	"editor.image.dragger.tooltip": "Cliquez ou faites glisser l'image vers la zone pour télécharger",
	"editor.image.float.left.tooltip": "Flottant à gauche",
	"editor.image.float.none.tooltip": "Sans flottement",
	"editor.image.float.right.tooltip": "Flottant à droite",
	"editor.image.dialog.title": "Ajouter une image",
	"editor.image.dialog.tab.url": "URL",
	"editor.image.dialog.tab.upload": "Télécharger",
	"editor.image.dialog.tab.uploadCrop": "Télécharger et recadrer",
	"editor.image.dialog.uploading": "Téléchargement en cours",
	"editor.link.dialog.inline": "En ligne",
	"editor.image.dialog.form.link": "Lien",
	"editor.image.dialog.placeholder": "Lien",
	"editor.image.dialog.form.alt": "Texte alternatif",
	"editor.image.dialog.form.aspectRatio": "Conserver le rapport d'aspect original",
	"editor.image.dialog.form.file": "Fichier",
	"editor.image.dialog.button.apply": "Appliquer",
	"editor.video.tooltip": "Vidéo",
	"editor.video.dialog.tab.upload": "Télécharger",
	"editor.video.dialog.uploading": "Téléchargement en cours",
	"editor.video.dialog.title": "Intégrer ou télécharger une vidéo",
	"editor.video.dialog.link": "Lien",
	"editor.video.dialog.placeholder": "Lien",
	"editor.video.dialog.button.apply": "Appliquer",
	"editor.table.tooltip": "Tableau",
	"editor.table.menu.insert_table": "Insérer un tableau",
	"editor.table.menu.insert_table.with_header_row": "Avec ligne d'en-tête",
	"editor.table.menu.add_column_before": "Ajouter une colonne avant",
	"editor.table.menu.add_column_after": "Ajouter une colonne après",
	"editor.table.menu.delete_column": "Supprimer la colonne",
	"editor.table.menu.add_row_before": "Ajouter une ligne avant",
	"editor.table.menu.add_row_after": "Ajouter une ligne après",
	"editor.table.menu.delete_row": "Supprimer la ligne",
	"editor.table.menu.merge_or_split_cells": "Fusionner ou diviser les cellules",
	"editor.table.menu.delete_table": "Supprimer le tableau",
	"editor.blockquote.tooltip": "Citation",
	"editor.horizontalrule.tooltip": "Ligne horizontale",
	"editor.code.tooltip": "Code",
	"editor.codeblock.tooltip": "Bloc de code",
	"editor.clear.tooltip": "Effacer le format",
	"editor.undo.tooltip": "Annuler",
	"editor.redo.tooltip": "Rétablir",
	"editor.fullscreen.tooltip.fullscreen": "Plein écran",
	"editor.fullscreen.tooltip.exit": "Quitter le plein écran",
	"editor.imageUpload.cancel": "Annuler",
	"editor.imageUpload.crop": "Recadrer",
	"editor.imageUpload.fileTypeNotSupported": "Type de fichier non pris en charge",
	"editor.imageUpload.fileSizeTooBig": "Taille du fichier trop importante, la taille maximale est",
	"editor.table.menu.insertColumnBefore": "Insérer une colonne avant",
	"editor.table.menu.insertColumnAfter": "Insérer une colonne après",
	"editor.table.menu.deleteColumn": "Supprimer la colonne",
	"editor.table.menu.insertRowAbove": "Insérer une ligne au-dessus",
	"editor.table.menu.insertRowBelow": "Insérer une ligne en-dessous",
	"editor.table.menu.deleteRow": "Supprimer la ligne",
	"editor.table.menu.mergeCells": "Fusionner les cellules",
	"editor.table.menu.splitCells": "Diviser les cellules",
	"editor.table.menu.deleteTable": "Supprimer le tableau",
	"editor.table.menu.setCellsBgColor": "Couleur de fond des cellules",
	"editor.emoji.tooltip": "Émoji",
	"editor.iframe.tooltip": "Iframe",
	"editor.searchAndReplace.tooltip": "Rechercher et remplacer",
	"editor.search.dialog.text": "Rechercher",
	"editor.replace.dialog.text": "Remplacer",
	"editor.replaceAll.dialog.text": "Remplacer tout",
	"editor.previous.dialog.text": "Précédent",
	"editor.next.dialog.text": "Suivant",
	no_result_found: "Aucun résultat trouvé",
	"Smileys & People": "Émojis et personnes",
	"Animals & Nature": "Animaux et nature",
	"Food & Drink": "Nourriture et boissons",
	Activity: "Activités",
	"Travel & Places": "Voyages et lieux",
	Object: "Objets",
	Symbol: "Symboles",
	Flags: "Drapeaux",
	"Frequently used": "Fréquemment utilisés",
	"editor.formula.dialog.text": "Formule",
	"editor.katex.tooltip": "Formule mathématique",
	"editor.exportPdf.tooltip": "Exporter en PDF",
	"editor.exportWord.tooltip": "Exporter en Word",
	"editor.importWord.tooltip": "Importer un document Word",
	"editor.importWord.limitSize": "La taille du fichier ne peut pas dépasser",
	"editor.importWord.converting": "Conversion du document Word, veuillez patienter...",
	"editor.importWord.convertError": "Erreur lors de l'analyse du document Word",
	"editor.importWord.importError": "Erreur lors de l'importation du document Word",
	"editor.textDirection.tooltip": "Direction du texte",
	"editor.textDirection.auto.tooltip": "Automatique",
	"editor.textDirection.ltr.tooltip": "De gauche à droite",
	"editor.textDirection.rtl.tooltip": "De droite à gauche",
	"editor.attachment.tooltip": "Pièce jointe",
	"editor.attachment.uploading": "Téléchargement en cours",
	"editor.attachment.please_upload": "Veuillez télécharger le fichier",
	"editor.imageGif.tooltip": "GIF",
	"editor.replace.caseSensitive": "Sensible à la casse",
	"editor.mermaid.tooltip": "Mermaid",
	"editor.twitter.tooltip": "Twitter",
	"editor.tooltip.flipX": "Retourner horizontalement",
	"editor.tooltip.flipY": "Retourner verticalement"
};

export default locale;
